<template>
    <div class="table-state">
        <div class="ticket-table blue" style="display: flex">
            <div class="ticket-table-header" style="display: flex">
                Ожидают
            </div>
            <div class="ticket-table-body" style="width: 17vw; display: flex">
                <div class="ticket-table-ticket" style="display: flex" v-for="(ticket, index) in spliceItems(ticketsStateLeft)" :key="index">
                    <div v-text="ticket.ticketNumber" class="ticketNumber"/>
                </div>
            </div>
        </div>
        <div class="ticket-table" style="width: 75vw; display: flex">
            <div class="ticket-table-header" style="display: flex">
                Готовы к выдаче
            </div>
            <div class="ticket-table-body" style="display: flex">
                <div class="ticket-table-ticket" style="display: flex" v-for="(ticket, index) in spliceItems(ticketsStateRight)" :key="index">
                    <div v-text="ticket.ticketNumber" class="ticketNumber"/>
                    <div class="arrow" style="display: flex">
                        <IconArrowShort/>
                    </div>
                    <div v-text="ticket.seatLabel" class="seatLabel"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import { mapState } from 'vuex'
import IconArrowShort from '@/components/Icons/IconArrowShort.vue'

export default {
    name: 'BauTable',
    components: {
        IconArrowShort
    },
    props: {
        tickets: {
            type: Array
        }
    },
    computed: {
        ...mapState({
            states: state => state.board.states,
            boardSize: state => state.board.size
        }),
        statesLeft () {
            return ['В очереди']
        },
        statesRight () {
            return ['Вызван', 'Обслуживается']
        },
        ticketsStateLeft () {
            return this.tickets.filter(ticket => this.statesLeft.some(state => ticket.getTitle().includes(state))).reverse()
        },
        ticketsStateRight () {
            return this.tickets.filter(ticket => this.statesRight.some(state => ticket.getTitle().includes(state)))
        }
    },
    methods: {
        spliceItems (items) {
            return items.slice(0, this.boardSize / 2)
        }
    }
}
</script>

<style>
.table-state {
    display: flex;
    justify-content: start;
    align-items: center;
    margin-top: 4vh;
    column-gap: 1.05vw;
    padding: 0 2vw;

    .ticket-table {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 1.85vh;

        border-radius: 32px;
        outline: clamp(4px, .1vw, 20px) #B3BFCC solid;
        outline-offset: clamp(-20px, -.1vw, -4px);
        overflow: hidden;
        height: 74vh;

        &.blue {
            background: #F1F7FF;
        }

        .ticket-table-header {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            padding: 0 1.9vw;
            background: var(--color-background-header);

            height: 8.4vh;
            color: var(--color-time);
            font-size: clamp(3rem, 2.7vw, 20rem);
            font-family: var(--font-main);
            line-height: 172px;
            width: 100%;
        }

        .ticket-table-body {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            align-content: flex-start;
            flex: 1 1 0;
            padding: 0 1.9vw;
            column-gap: .83vw;
            flex-wrap: wrap;
            width: 100%;

            .ticket-table-ticket {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex: 0 0 calc(50% - .42vw);
                height: 7vh;
                padding: .4vh 0;
                column-gap: .85vw;

                color: #1C1C1C;
                font-family: var(--font-title);
                font-weight: 400;
                line-height: clamp(3rem, 2.7vw, 20rem);
                font-size: clamp(3rem, 2.7vw, 20rem);
                word-wrap: break-word;

                .ticketNumber {
                    min-width: 7.5vw;
                }

                .arrow {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 2vw;
                    padding: 0 .52vw;
                    height: 100%;
                }
            }
        }
    }
}

.logo-img {
    height: var(--logo-size-height);
    width: var(--logo-size-width);
}
</style>
